import type { GridValueFormatterParams } from "@mui/x-data-grid";

const fallbackValue = (params: GridValueFormatterParams<string>, fallback = '-') =>
    params.value?.length > 0 ? params.value : fallback;

export default fallbackValue;
